import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const MainContainer = styled(Grid)({
  width: "100%",
  heigth: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
});

export const StatusAmountContainer = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
});

export const StatusAmountBlock = styled(Grid)({
  width: "fit-content",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "5px",
});

export const LegalEntityBlock = styled(Grid)({
  width: "fit-content",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "5px",
});
